<template>
    <v-app class="min-h-screen">
        <v-app-bar
            app
            color="white"
            height="64"
            elevate-on-scroll
            :class="$vuetify.breakpoint.smAndUp ? 'px-6' : null"
            ><v-container class="flex items-center">
                <a href="https://musicologielessons.com">
                    <jet-application-logo
                        class="block w-auto"
                        :class="$vuetify.breakpoint.xs ? 'h-6' : 'h-9'"
                /></a>
                <v-spacer />
                <div class="flex gap-2 justify-end">
                    <SoliBtn
                        gradient="gradient-orange"
                        href="/login"
                        class="white--text"
                        >Login</SoliBtn
                    >
                </div>
            </v-container>
        </v-app-bar>

        <v-main>
            <v-container>
                <p>
                    Our clients opt-in by visiting go.musicologie.com or
                    musicologie.com/get-started and fill out our get started
                    form, including their phone number. Our form very clearly
                    states that they are opting- in to receive text messages
                    with opt-out instructions and that they are agreeing to
                    receive text messages by submitting the form. They are
                    additionally presented with our privacy policy, which
                    outlines our text message use and opt-out instructions in
                    more detail. Opt-out can occur by responding STOP to any of
                    our messages or by adjusting their communication preferences
                    in their profile within our website/app.
                </p>
                <v-img
                    src="/notification-preferences-example.png"
                    width="400"
                />
                <v-img src="/opt-in-example-no-check.png" width="100%" />
            </v-container>
        </v-main>

        <SiteFooter />
    </v-app>
</template>

<script>
import JetApplicationLogo from "./../Jetstream/ApplicationLogo";
import SiteFooter from "../Layouts/Components/SiteFooter.vue";

export default {
    components: {
        JetApplicationLogo,
        SiteFooter,
    },
    data: function () {
        return {
            features: [
                {
                    icon: "storefront",
                    title: "For Musicologie",
                    text: "We designed our software in-house for a seamless experience. ",
                },
                {
                    icon: "school",
                    title: "For Teachers",
                    text: "Manage your availability. Share lesson notes. Everything in one place.",
                },
                {
                    icon: "people",
                    title: "For Students",
                    text: "Easy rescheduling. Explore classes near you. Stay connected.",
                },
            ],
        };
    },
};
</script>

<style scoped></style>
